import io from "socket.io-client";
import axios from "axios";
import {
  SOCKET,
  Event,
  sendNotfication,
  DEVELOPMENT,
  Game,
  SITE,
  API,
} from "./Helper";
import storage from "./Storage";
import { objectEach } from "highcharts";

/**
 * Socket URL
 */
const ws = SOCKET;

let api = API + "/rate";

 axios({  headers:{
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods":"*",
    'content-type': '*',
    'Accept': 'application/json',
  },
 
  url: api,
  method: "GET",
}).then(function (req) {
  var res = req.data;
  Object.keys(res).forEach(function (name, key) {
    let val = res[name];
    Game[name] = parseFloat(val);
  });
});
// fetch(api).then(function(req){
//   var res = req.formData;
//   objectEach.keys(res).forEach(function(name,key) {

//     let val = res[name];
//     Game[name] = parseFloat(val);
    
//   });
// }
// );

/**
 * Initialize Socket Connection
 */
let socket;

export const connect = (token) => {
  console.log('[Socket] Connecting to:', ws);
  socket = io.connect(ws, {
    secure: DEVELOPMENT ? false : true,
    withCredentials: false,
    // Keep 'websocket' first with 'polling' as fallback.
    // The app encodes socket payloads as a Blob (see Helper.encode). Blobs
    // round-trip correctly as binary over websocket, but NOT over HTTP
    // long-polling — over polling the login payload fails to decode on the
    // backend, so no login response ever comes back ("Connection timed out").
    // So we must start on websocket. 'polling' stays as a fallback so devices
    // that cannot open a websocket at all can still connect.
    transports: ['websocket', 'polling'],
    upgrade: true,
    rememberUpgrade: true,
    // Keep retrying on flaky networks so login does not get stuck.
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    query: {
      auth_token: token,
      user_key: storage.getKey("key"),
    },
  });
};

if (!DEVELOPMENT) {
  if (storage.getKey("mthfk") === null) {
    connect(storage.getKey("token"));
  }
} else {
  connect(storage.getKey("token"));
}

let dis = false;

socket.on("connect", () => {
  console.log('[Socket] Connected successfully to:', ws);
  Event.emit("connect");
  if (DEVELOPMENT) {
    if (dis) {
      console.clear();
    }
  }
});

socket.on("connect_error", (err) => {
  console.error('[Socket] Connection error:', err.message);
});

/*
 * Disconnect Server
 */
socket.on("disconnect", () => {
  Event.emit("disconnect");
  dis = true;
});

/*
 * Force logout when same account logs in from another device
 */
socket.on("FORCE_LOGOUT", () => {
  // Clear all auth data
  storage.setKey('logged', false);
  storage.setKey('token', null);
  storage.setKey('name', null);
  storage.setKey('email', null);
  storage.setKey('credit', null);
  localStorage.removeItem('showLoginSuccessModal');
  // Show toast notification
  sendNotfication('Your account has been logged in from another device.', 'warning', 'top-center');
  // Redirect to home after short delay
  setTimeout(() => {
    window.location.href = '/';
  }, 2000);
});

/*
 * Disconnect Server for Hacker
 */
Event.on("mthfk", () => {
  if (!DEVELOPMENT) socket.disconnect();
});

export default socket;
